import React, { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  AddCollectionButton,
  Content,
  Header,
  ListContainer,
  LoaderContainer,
  Navigator,
  NumOfUsersText,
  PageContainer,
  RowItem,
  Title,
} from './CollectionsPage.styles';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectFetchCollectionsInfo } from '../../../store/slices/collections/slice';
import { fetchCollections } from '../../../store/slices/collections/asyncThunks';
import { Spinner } from '../../../components';
import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg';
import NewCollectionFormModal from '../../../components/modals/NewCollectionFormModal/NewCollectionFormModal';
import { Text16Regular } from '../../../components/utils/Text/Text.styles';
import { formatNumber } from '../../../utils/util';
import { COLLECTION_USERS } from '../../../components/App/routes';

const CollectionsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modalRef = useRef();

  const { collectionId, influencerId } = useParams();

  const [showContent, setShowContent] = useState(false);
  const smallScreen = useMediaQuery({ minWidth: 0, maxWidth: 768 });
  const [selectedCollection, setSelectedCollection] = useState(null);

  const { data, pending } = useSelector(selectFetchCollectionsInfo);

  useEffect(() => {
    dispatch(fetchCollections({ ...(influencerId && { influencerId }) }));
  }, [dispatch, influencerId]);

  useEffect(() => {
    setShowContent(!smallScreen);
  }, [smallScreen]);

  useEffect(() => {
    if (collectionId) {
      setSelectedCollection({ _id: collectionId });
    }
  }, [collectionId]);

  return (
    <PageContainer>
      {(!smallScreen || (smallScreen && !showContent)) && (
        <Navigator>
          <Header>
            <Title>Collections</Title>
            <AddCollectionButton onClick={() => modalRef.current.show()}>
              <PlusIcon />
            </AddCollectionButton>
          </Header>
          {pending ? (
            <LoaderContainer>
              <Spinner width={120} height={120} />
            </LoaderContainer>
          ) : (
            <ListContainer>
              {[{ _id: 'all', name: 'All Fans' }, ...data].map(collection => {
                return (
                  <RowItem
                    $selected={collection._id === selectedCollection?._id}
                    key={collection._id}
                    onClick={() => {
                      setSelectedCollection(collection);
                      setShowContent(true);
                      navigate(COLLECTION_USERS.replace(':collectionId', collection._id), {
                        state: { collectionName: collection.name },
                      });
                    }}>
                    <Text16Regular>{collection.name}</Text16Regular>
                    {!isNaN(collection.totalUsers) && (
                      <NumOfUsersText>{formatNumber(collection.totalUsers)} users</NumOfUsersText>
                    )}
                  </RowItem>
                );
              })}
            </ListContainer>
          )}
        </Navigator>
      )}
      {showContent && (
        <Content>
          <Outlet context={[setShowContent]} />
        </Content>
      )}
      <NewCollectionFormModal
        modalRef={modalRef}
        influencerId={influencerId}
        onSuccess={() => {
          dispatch(fetchCollections({ ...(influencerId && { influencerId }) }));
        }}
      />
    </PageContainer>
  );
};

export default CollectionsPage;
